/* LVC: feedback tactil y prioridad de imagenes visibles. No interceptar la navegacion. */
(function () {
  'use strict';
  if (!window.matchMedia || !window.matchMedia('(max-width: 1024px)').matches) return;
  function prioritizeVisibleImages() {
    var imgs = document.querySelectorAll('main img, .shopify-section img');
    var count = 0;
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (!img.getAttribute('src') && !img.getAttribute('srcset')) continue;
      var r = img.getBoundingClientRect();
      if (r.width === 0 || r.height === 0) continue;
      if (r.top < window.innerHeight * 1.2 && r.bottom > -40) {
        if (count < 3) {
          img.setAttribute('fetchpriority', 'high');
          img.setAttribute('loading', 'eager');
          count++;
        }
      } else if (r.top > window.innerHeight * 2.5 && !img.complete && !img.hasAttribute('loading')) {
        img.setAttribute('loading', 'lazy');
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prioritizeVisibleImages, { once: true });
  } else {
    prioritizeVisibleImages();
  }
})();
